<div class="container" *ngIf="loaded">
    <div class="row">
        <div class="col section-title-full" role="banner">
            <h1>
                <span i18n>Formulario de registro</span>
            </h1>
        </div>
    </div>
</div>

<main id="main-content" class="container" *ngIf="loaded">

    <div class="row align-items-center">
        <div class="col">
            <p class="text-destacado" i18n>Es necesario rellenar el siguiente formulario con los datos solicitados</p>
        </div>
    </div>

    <div class="mb-3">
        <h2 class="my-4" i18n>Tipo de solicitante</h2>
        <div class="card">
            <div class="row">
                <div class="col-12 mb-3">
                    <label for="tipo-solicitante" class="form-label">
                        <span i18n>Tipo de solicitante</span>: <span class="required" title="obligatorio">*</span>
                    </label>
                    <select id="tipo-solicitante" class="form-select" [(ngModel)]="applicant.applicantType"
                        (ngModelChange)="clearOtherForms()"
                        [ngClass]="{'is-invalid': shouldShowError('applicantType', applicant.applicantType)}"
                        (blur)="markAsTouched('applicantType')" required>
                        <option value="" i18n>Seleccione tipo</option>
                        <option value="Individual" i18n>Individual</option>
                        <option value="Represented" i18n>Representado</option>
                        <option value="Company" i18n>Compañia</option>
                    </select>
                    <div *ngIf="shouldShowError('applicantType', applicant.applicantType)" class="invalid-feedback"
                        i18n>
                        Campo requerido
                    </div>
                </div>
            </div>
        </div>

        <!-- Sección para "Individual" -->
        <ng-container *ngIf="applicant.applicantType == 'Individual' && applicant.individual">
            <h2 class="my-4" i18n>Datos de la persona interesada</h2>
            <div class="card">
                <div class="row">
                    <!-- Nombre -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="nombre" class="form-label">
                            <span i18n>Nombre</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="nombre"
                            [ngClass]="{'is-invalid': shouldShowError('individualName', applicant.individual.applicantIdentification.name)}"
                            [(ngModel)]="applicant.individual.applicantIdentification.name"
                            (ngModelChange)="checkValid()" (blur)="markAsTouched('individualName')" required>
                        <div *ngIf="shouldShowError('individualName', applicant.individual.applicantIdentification.name)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Primer apellido -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="primer-apellido" class="form-label">
                            <span i18n>Primer apellido</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="primer-apellido"
                            [ngClass]="{'is-invalid': shouldShowError('individualFirstSurname', applicant.individual.applicantIdentification.firstSurname)}"
                            [(ngModel)]="applicant.individual.applicantIdentification.firstSurname"
                            (ngModelChange)="checkValid()" (blur)="markAsTouched('individualFirstSurname')" required>
                        <div *ngIf="shouldShowError('individualFirstSurname', applicant.individual.applicantIdentification.firstSurname)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Segundo apellido (opcional) -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="segundo-apellido" class="form-label">
                            <span i18n>Segundo apellido</span>:
                        </label>
                        <input type="text" class="form-control" id="segundo-apellido"
                            [(ngModel)]="applicant.individual.applicantIdentification.secondSurname">
                    </div>

                    <!-- Fecha de nacimiento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="fecha-nacimiento" class="form-label">
                            <span i18n>Fecha de nacimiento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="date" class="form-control" id="fecha-nacimiento"
                            [ngClass]="{'is-invalid': shouldShowError('individualDateOfBirth', applicant.individual.applicantIdentification.dateOfBirth.date)}"
                            [(ngModel)]="applicant.individual.applicantIdentification.dateOfBirth.date"
                            (ngModelChange)="checkValid()" (blur)="markAsTouched('individualDateOfBirth')" required>
                        <div *ngIf="shouldShowError('individualDateOfBirth', applicant.individual.applicantIdentification.dateOfBirth.date)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Tipo de documento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="tipo-documento" class="form-label">
                            <span i18n>Tipo de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <select id="tipo-documento" class="form-select"
                            [(ngModel)]="applicant.individual.applicantIdentification.documentType"
                            (ngModelChange)="checkValid()"
                            [ngClass]="{'is-invalid': shouldShowError('individualDocumentType', applicant.individual.applicantIdentification.documentType)}"
                            (blur)="markAsTouched('individualDocumentType')" required>
                            <option value="">Seleccione una opción</option>
                            <option value="NIF">NIF</option>
                            <option value="NIE">NIE</option>
                            <option value="Passport">Pasaporte</option>
                            <option value="National ID">ID nacional</option>
                        </select>
                        <div *ngIf="shouldShowError('individualDocumentType', applicant.individual.applicantIdentification.documentType)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Número de documento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="firstname" class="form-label">
                            <span i18n>Numéro de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="firstname"
                            [ngClass]="{'is-invalid': shouldShowError('individualDocumentIdentification', applicant.individual.applicantIdentification.documentIdentification)}"
                            [(ngModel)]="applicant.individual.applicantIdentification.documentIdentification"
                            (ngModelChange)="checkValid()" (blur)="markAsTouched('individualDocumentIdentification')"
                            required>
                        <div *ngIf="shouldShowError('individualDocumentIdentification', applicant.individual.applicantIdentification.documentIdentification)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>
                </div>
            </div>

            <h2 class="my-4" i18n>Datos de contacto del interesado</h2>
            <div class="card">
                <div class="row">
                    <!-- Correo electrónico -->
                    <div class="col-sm-6 mb-3">
                        <label for="email" class="form-label">
                            <span i18n>Correo electrónico</span>: <span class="required" title="Obligatorio">*</span>
                        </label>
                        <input type="email" class="form-control" id="email"
                            [ngClass]="{'is-invalid': shouldShowError('individualEmail', applicant.individual.applicantContact.email)}"
                            [(ngModel)]="applicant.individual.applicantContact.email" (ngModelChange)="checkValid()"
                            (blur)="markAsTouched('individualEmail')" required>
                        <div *ngIf="shouldShowError('individualEmail', applicant.individual.applicantContact.email)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Confirmar correo electrónico -->
                    <div class="col-sm-6 mb-3">
                        <label for="confirm-email" class="form-label">
                            <span i18n>Confirmar correo electrónico</span>: <span class="required"
                                title="Obligatorio">*</span>
                        </label>
                        <input type="email" class="form-control" id="confirm-email"
                            [ngClass]="{'is-invalid': shouldShowError('confirmEmail', confirmEmail)}"
                            [(ngModel)]="confirmEmail" (ngModelChange)="checkValid()"
                            (blur)="markAsTouched('confirmEmail')" required>
                        <div *ngIf="shouldShowError('confirmEmail', confirmEmail)" class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Teléfono (opcional) y demás campos de contacto se dejan sin validación obligatoria -->
                    <div class="col-sm-6 col-xl-6 mb-3">
                        <label for="telefono" class="form-label">
                            <span i18n>Teléfono de contacto</span>:
                        </label>
                        <input type="text" class="form-control" id="telefono"
                            [(ngModel)]="applicant.individual.applicantContact.phoneNumber">
                    </div>

                    <div class="col-sm-6 col-xl-6 mb-3">
                        <label for="pais-residencia" class="form-label">
                            <span i18n>País de residencia</span>:
                        </label>
                        <select id="pais-residencia" class="form-select"
                            [(ngModel)]="applicant.individual.applicantContact.countryCode">
                            <option value="0" i18n>Selecciona un país</option>
                            @for (country of countries; track country.code) {
                            <option value="{{country.code}}">{{country.name}}</option>
                            }
                        </select>
                    </div>

                    <!-- Los demás campos de dirección se mantienen sin esquema obligatorio -->
                    <!-- ... -->
                </div>
            </div>
        </ng-container>

        <!-- Sección para "Represented" -->
        <ng-container *ngIf="applicant.applicantType == 'Represented' && applicant.represented">
            <h2 class="my-4" i18n>Datos del interesado</h2>
            <div class="card">
                <div class="row">
                    <!-- Nombre -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="nombre" class="form-label">
                            <span i18n>Nombre</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="nombre"
                            [ngClass]="{'is-invalid': shouldShowError('representedName', applicant.represented.applicantIdentification.name)}"
                            [(ngModel)]="applicant.represented.applicantIdentification.name"
                            (ngModelChange)="checkValid()" (blur)="markAsTouched('representedName')" required>
                        <div *ngIf="shouldShowError('representedName', applicant.represented.applicantIdentification.name)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Primer apellido -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="primer-apellido" class="form-label">
                            <span i18n>Primer apellido</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="primer-apellido"
                            [ngClass]="{'is-invalid': shouldShowError('representedFirstSurname', applicant.represented.applicantIdentification.firstSurname)}"
                            [(ngModel)]="applicant.represented.applicantIdentification.firstSurname"
                            (ngModelChange)="checkValid()" (blur)="markAsTouched('representedFirstSurname')" required>
                        <div *ngIf="shouldShowError('representedFirstSurname', applicant.represented.applicantIdentification.firstSurname)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Segundo apellido (opcional) -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="segundo-apellido" class="form-label">
                            <span i18n>Segundo apellido</span>:
                        </label>
                        <input type="text" class="form-control" id="segundo-apellido"
                            [(ngModel)]="applicant.represented.applicantIdentification.secondSurname">
                    </div>

                    <!-- Fecha de nacimiento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="fecha-nacimiento" class="form-label">
                            <span i18n>Fecha de nacimiento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="date" class="form-control" id="fecha-nacimiento"
                            [ngClass]="{'is-invalid': shouldShowError('representedDateOfBirth', applicant.represented.applicantIdentification.dateOfBirth.date)}"
                            [(ngModel)]="applicant.represented.applicantIdentification.dateOfBirth.date"
                            (ngModelChange)="checkValid()" (blur)="markAsTouched('representedDateOfBirth')" required>
                        <div *ngIf="shouldShowError('representedDateOfBirth', applicant.represented.applicantIdentification.dateOfBirth.date)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Tipo de documento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="tipo-documento" class="form-label">
                            <span i18n>Tipo de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <select id="tipo-documento" class="form-select"
                            [(ngModel)]="applicant.represented.applicantIdentification.documentType"
                            (ngModelChange)="checkValid()"
                            [ngClass]="{'is-invalid': shouldShowError('representedDocumentType', applicant.represented.applicantIdentification.documentType)}"
                            (blur)="markAsTouched('representedDocumentType')" required>
                            <option value="">Seleccione una opción</option>
                            <option value="NIF">NIF</option>
                            <option value="NIE">NIE</option>
                            <option value="Passport">Pasaporte</option>
                            <option value="National ID">ID nacional</option>
                        </select>
                        <div *ngIf="shouldShowError('representedDocumentType', applicant.represented.applicantIdentification.documentType)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Número de documento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="firstname" class="form-label">
                            <span i18n>Numéro de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="firstname"
                            [ngClass]="{'is-invalid': shouldShowError('representedDocumentIdentification', applicant.represented.applicantIdentification.documentIdentification)}"
                            [(ngModel)]="applicant.represented.applicantIdentification.documentIdentification"
                            (ngModelChange)="checkValid()" (blur)="markAsTouched('representedDocumentIdentification')"
                            required>
                        <div *ngIf="shouldShowError('representedDocumentIdentification', applicant.represented.applicantIdentification.documentIdentification)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>
                </div>
            </div>

            <h2 class="my-4" i18n>Datos de contacto del interesado</h2>
            <div class="card">
                <div class="row">
                    <!-- Correo electrónico -->
                    <div class="col-sm-6 mb-3">
                        <label for="email" class="form-label">
                            <span i18n>Correo electrónico</span>: <span class="required" title="Obligatorio">*</span>
                        </label>
                        <input type="email" class="form-control" id="email"
                            [ngClass]="{'is-invalid': shouldShowError('representedEmail', applicant.represented.applicantContact.email)}"
                            [(ngModel)]="applicant.represented.applicantContact.email" (ngModelChange)="checkValid()"
                            (blur)="markAsTouched('representedEmail')" required>
                        <div *ngIf="shouldShowError('representedEmail', applicant.represented.applicantContact.email)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Confirmar correo electrónico -->
                    <div class="col-sm-6 mb-3">
                        <label for="confirm-email" class="form-label">
                            <span i18n>Confirmar correo electrónico</span>: <span class="required"
                                title="Obligatorio">*</span>
                        </label>
                        <input type="email" class="form-control" id="confirm-email"
                            [ngClass]="{'is-invalid': shouldShowError('representedConfirmEmail', confirmEmail)}"
                            [(ngModel)]="confirmEmail" (ngModelChange)="checkValid()"
                            (blur)="markAsTouched('representedConfirmEmail')" required>
                        <div *ngIf="shouldShowError('representedConfirmEmail', confirmEmail)" class="invalid-feedback"
                            i18n>
                            Campo requerido
                        </div>
                    </div>
                    <!-- Los demás campos de contacto se mantienen sin validación obligatoria -->
                </div>
            </div>

            <h2 class="my-4" i18n>Datos del representado</h2>
            <div class="card">
                <div class="row">
                    <!-- Relación con el representado -->
                    <div class="col-12 mb-3">
                        <label for="tipo-solicitante" class="form-label">
                            <span i18n>Relación con el representado</span>: <span class="required"
                                title="obligatorio">*</span>
                        </label>
                        <select id="tipo-solicitante" class="form-select"
                            [(ngModel)]="applicant.represented.relationship" (ngModelChange)="checkValid()"
                            [ngClass]="{'is-invalid': shouldShowError('representedRelationship', applicant.represented.relationship)}"
                            (blur)="markAsTouched('representedRelationship')" required>
                            <option value="" i18n>Seleccione tipo</option>
                            <option *ngFor="let r of relationships" [value]="r.name">{{r.name}}</option>
                        </select>
                        <div *ngIf="shouldShowError('representedRelationship', applicant.represented.relationship)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Nombre del representante -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="nombre" class="form-label">
                            <span i18n>Nombre</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="nombre"
                            [ngClass]="{'is-invalid': shouldShowError('representativeName', applicant.represented.representativeIdentification.name)}"
                            [(ngModel)]="applicant.represented.representativeIdentification.name"
                            (ngModelChange)="checkValid()" (blur)="markAsTouched('representativeName')" required>
                        <div *ngIf="shouldShowError('representativeName', applicant.represented.representativeIdentification.name)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Primer apellido del representante -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="primer-apellido" class="form-label">
                            <span i18n>Primer apellido</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="primer-apellido"
                            [ngClass]="{'is-invalid': shouldShowError('representativeFirstSurname', applicant.represented.representativeIdentification.firstSurname)}"
                            [(ngModel)]="applicant.represented.representativeIdentification.firstSurname"
                            (ngModelChange)="checkValid()" (blur)="markAsTouched('representativeFirstSurname')"
                            required>
                        <div *ngIf="shouldShowError('representativeFirstSurname', applicant.represented.representativeIdentification.firstSurname)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Segundo apellido (opcional) -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="segundo-apellido" class="form-label">
                            <span i18n>Segundo apellido</span>:
                        </label>
                        <input type="text" class="form-control" id="segundo-apellido"
                            [(ngModel)]="applicant.represented.representativeIdentification.secondSurname">
                    </div>

                    <!-- Fecha de nacimiento del representante -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="fecha-nacimiento" class="form-label">
                            <span i18n>Fecha de nacimiento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="date" class="form-control" id="fecha-nacimiento"
                            [ngClass]="{'is-invalid': shouldShowError('representativeDateOfBirth', applicant.represented.representativeIdentification.dateOfBirth.date)}"
                            [(ngModel)]="applicant.represented.representativeIdentification.dateOfBirth.date"
                            (ngModelChange)="checkValid()" (blur)="markAsTouched('representativeDateOfBirth')" required>
                        <div *ngIf="shouldShowError('representativeDateOfBirth', applicant.represented.representativeIdentification.dateOfBirth.date)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Tipo de documento del representante -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="tipo-documento" class="form-label">
                            <span i18n>Tipo de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <select id="tipo-documento" class="form-select"
                            [(ngModel)]="applicant.represented.representativeIdentification.documentType"
                            (ngModelChange)="checkValid()"
                            [ngClass]="{'is-invalid': shouldShowError('representativeDocumentType', applicant.represented.representativeIdentification.documentType)}"
                            (blur)="markAsTouched('representativeDocumentType')" required>
                            <option value="">Seleccione una opción</option>
                            <option value="NIF">NIF</option>
                            <option value="NIE">NIE</option>
                            <option value="Passport">Pasaporte</option>
                            <option value="National ID">ID nacional</option>
                        </select>
                        <div *ngIf="shouldShowError('representativeDocumentType', applicant.represented.representativeIdentification.documentType)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Número de documento del representante -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="firstname" class="form-label">
                            <span i18n>Numéro de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="firstname"
                            [ngClass]="{'is-invalid': shouldShowError('representativeDocumentIdentification', applicant.represented.representativeIdentification.documentIdentification)}"
                            [(ngModel)]="applicant.represented.representativeIdentification.documentIdentification"
                            (ngModelChange)="checkValid()"
                            (blur)="markAsTouched('representativeDocumentIdentification')" required>
                        <div *ngIf="shouldShowError('representativeDocumentIdentification', applicant.represented.representativeIdentification.documentIdentification)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>
                </div>
            </div>

            <h2 class="my-4" i18n>Datos de contacto del representado</h2>
            <div class="card">
                <div class="row">
                    <!-- Teléfono (opcional) y demás campos de contacto se mantienen sin validación obligatoria -->
                    <div class="col-sm-6 mb-3">
                        <label for="telefono" class="form-label">
                            <span i18n>Teléfono de contacto</span>:
                        </label>
                        <input type="text" class="form-control" id="telefono"
                            [(ngModel)]="applicant.represented.representativeContact.phoneNumber">
                    </div>

                    <div class="col-sm-6 mb-3">
                        <label for="pais-residencia" class="form-label">
                            <span i18n>País de residencia</span>:
                        </label>
                        <select id="pais-residencia" class="form-select"
                            [(ngModel)]="applicant.represented.representativeContact.countryCode">
                            <option value="0" i18n>Selecciona un país</option>
                            @for (country of countries; track country.code) {
                            <option value="{{country.code}}">{{country.name}}</option>
                            }
                        </select>
                    </div>

                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="provincia" class="form-label">
                            <span i18n>Provincia</span>:
                        </label>
                        <select id="provincia" class="form-select"
                            [(ngModel)]="applicant.represented.representativeContact.province"
                            (ngModelChange)="loadMunicipalities()">
                            <option value="" i18n>Selecciona una provincia</option>
                            @for (province of provinces; track province.code) {
                            <option value="{{province.name}}">{{province.name}}</option>
                            }
                        </select>
                    </div>

                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="municipio" class="form-label">
                            <span i18n>Municipio</span>:
                        </label>
                        <select id="municipio" class="form-select"
                            [(ngModel)]="applicant.represented.representativeContact.municipality"
                            [disabled]="applicant.represented.representativeContact.province == ''">
                            <option value="" i18n>Selecciona un municipio</option>
                            @for (municipality of municipalities; track municipality.code) {
                            <option value="{{municipality.name}}">{{municipality.name}}</option>
                            }
                        </select>
                    </div>

                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="cp" class="form-label">
                            <span i18n>Código postal</span>:
                        </label>
                        <input type="text" class="form-control" id="cp"
                            [(ngModel)]="applicant.represented.representativeContact.postalCode">
                    </div>
                    <!-- Los demás campos de dirección se mantienen sin validación -->
                </div>
            </div>
        </ng-container>

        <!-- Sección para "Company" -->
        <ng-container *ngIf="applicant.applicantType == 'Company' && applicant.company">
            <h2 class="my-4" i18n>Datos del interesado</h2>
            <div class="card">
                <div class="row">
                    <!-- Nombre de la empresa -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="nombre" class="form-label">
                            <span i18n>Nombre</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="nombre"
                            [ngClass]="{'is-invalid': shouldShowError('companyName', applicant.company.applicantIdentification.name)}"
                            [(ngModel)]="applicant.company.applicantIdentification.name" (ngModelChange)="checkValid()"
                            (blur)="markAsTouched('companyName')" required>
                        <div *ngIf="shouldShowError('companyName', applicant.company.applicantIdentification.name)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Primer apellido (si aplica) -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="primer-apellido" class="form-label">
                            <span i18n>Primer apellido</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="primer-apellido"
                            [ngClass]="{'is-invalid': shouldShowError('companyFirstSurname', applicant.company.applicantIdentification.firstSurname)}"
                            [(ngModel)]="applicant.company.applicantIdentification.firstSurname"
                            (ngModelChange)="checkValid()" (blur)="markAsTouched('companyFirstSurname')" required>
                        <div *ngIf="shouldShowError('companyFirstSurname', applicant.company.applicantIdentification.firstSurname)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Segundo apellido (opcional) -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="segundo-apellido" class="form-label">
                            <span i18n>Segundo apellido</span>:
                        </label>
                        <input type="text" class="form-control" id="segundo-apellido"
                            [(ngModel)]="applicant.company.applicantIdentification.secondSurname">
                    </div>

                    <!-- Fecha de nacimiento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="fecha-nacimiento" class="form-label">
                            <span i18n>Fecha de nacimiento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="date" class="form-control" id="fecha-nacimiento"
                            [ngClass]="{'is-invalid': shouldShowError('companyDateOfBirth', applicant.company.applicantIdentification.dateOfBirth.date)}"
                            [(ngModel)]="applicant.company.applicantIdentification.dateOfBirth.date"
                            (ngModelChange)="checkValid()" (blur)="markAsTouched('companyDateOfBirth')" required>
                        <div *ngIf="shouldShowError('companyDateOfBirth', applicant.company.applicantIdentification.dateOfBirth.date)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Tipo de documento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="tipo-documento" class="form-label">
                            <span i18n>Tipo de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <select id="tipo-documento" class="form-select"
                            [(ngModel)]="applicant.company.applicantIdentification.documentType"
                            (ngModelChange)="checkValid()"
                            [ngClass]="{'is-invalid': shouldShowError('companyDocumentType', applicant.company.applicantIdentification.documentType)}"
                            (blur)="markAsTouched('companyDocumentType')" required>
                            <option value="">Seleccione una opción</option>
                            <option value="NIF">NIF</option>
                            <option value="NIE">NIE</option>
                            <option value="Passport">Pasaporte</option>
                            <option value="National ID">ID nacional</option>
                        </select>
                        <div *ngIf="shouldShowError('companyDocumentType', applicant.company.applicantIdentification.documentType)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Número de documento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="firstname" class="form-label">
                            <span i18n>Numéro de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="firstname"
                            [ngClass]="{'is-invalid': shouldShowError('companyDocumentIdentification', applicant.company.applicantIdentification.documentIdentification)}"
                            [(ngModel)]="applicant.company.applicantIdentification.documentIdentification"
                            (ngModelChange)="checkValid()" (blur)="markAsTouched('companyDocumentIdentification')"
                            required>
                        <div *ngIf="shouldShowError('companyDocumentIdentification', applicant.company.applicantIdentification.documentIdentification)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>
                </div>
            </div>

            <h2 class="my-4" i18n>Datos de contacto del interesado</h2>
            <div class="card">
                <div class="row">
                    <!-- Correo electrónico -->
                    <div class="col-sm-6 mb-3">
                        <label for="email" class="form-label">
                            <span i18n>Correo electrónico</span>: <span class="required" title="Obligatorio">*</span>
                        </label>
                        <input type="email" class="form-control" id="email"
                            [ngClass]="{'is-invalid': shouldShowError('companyEmail', applicant.company.applicantContact.email)}"
                            [(ngModel)]="applicant.company.applicantContact.email" (ngModelChange)="checkValid()"
                            (blur)="markAsTouched('companyEmail')" required>
                        <div *ngIf="shouldShowError('companyEmail', applicant.company.applicantContact.email)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Confirmar correo electrónico -->
                    <div class="col-sm-6 mb-3">
                        <label for="confirm-email" class="form-label">
                            <span i18n>Confirmar correo electrónico</span>: <span class="required"
                                title="Obligatorio">*</span>
                        </label>
                        <input type="email" class="form-control" id="confirm-email"
                            [ngClass]="{'is-invalid': shouldShowError('companyConfirmEmail', confirmEmail)}"
                            [(ngModel)]="confirmEmail" (ngModelChange)="checkValid()"
                            (blur)="markAsTouched('companyConfirmEmail')" required>
                        <div *ngIf="shouldShowError('companyConfirmEmail', confirmEmail)" class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Teléfono (opcional) y demás campos de contacto se mantienen sin validación obligatoria -->
                    <div class="col-sm-6 mb-3">
                        <label for="telefono" class="form-label">
                            <span i18n>Teléfono de contacto</span>:
                        </label>
                        <input type="text" class="form-control" id="telefono"
                            [(ngModel)]="applicant.company.applicantContact.phoneNumber">
                    </div>

                    <div class="col-sm-6 mb-3">
                        <label for="pais-residencia" class="form-label">
                            <span i18n>País de residencia</span>:
                        </label>
                        <select id="pais-residencia" class="form-select"
                            [(ngModel)]="applicant.company.applicantContact.countryCode">
                            <option value="0" i18n>Selecciona un país</option>
                            @for (country of countries; track country.code) {
                            <option value="{{country.code}}">{{country.name}}</option>
                            }
                        </select>
                    </div>
                    <!-- Los demás campos de dirección se mantienen sin validación -->
                </div>
            </div>
        </ng-container>

        <h2 class="my-4" *ngIf="applicant.applicantType" i18n>Datos de autenticación</h2>
        <div class="card" *ngIf="applicant.applicantType">
            <div class="row">
                <div class="col-sm-6 col-md-4">
                    <label for="username" class="form-label">
                        <span i18n>Usuario</span>: <span class="required" title="obligatorio">*</span>
                    </label>
                    <input type="text" class="form-control" id="username" *ngIf="applicant.individual"
                        [(ngModel)]="applicant.individual.applicantIdentification.documentIdentification" disabled>
                    <input type="text" class="form-control" id="username" *ngIf="applicant.represented"
                        [(ngModel)]="applicant.represented.applicantIdentification.documentIdentification" disabled>
                    <input type="text" class="form-control" id="username" *ngIf="applicant.company"
                        [(ngModel)]="applicant.company.applicantIdentification.documentIdentification" disabled>
                </div>

                <div class="col-sm-6 col-md-4">
                    <label for="password" class="form-label">
                        <span i18n>Contraseña</span>: <span class="required" title="obligatorio">*</span>
                    </label>
                    <input type="password" class="form-control" id="password"
                        [ngClass]="{'is-invalid': shouldShowError('password', password)}" [(ngModel)]="password"
                        (ngModelChange)="checkValid()" (blur)="markAsTouched('password')" required>
                    <div *ngIf="shouldShowError('password', password)" class="invalid-feedback" i18n>
                        Campo requerido
                    </div>
                </div>

                <div class="col-sm-6 col-md-4">
                    <label for="confirm-password" class="form-label">
                        <span i18n>Confirmar Contraseña</span>: <span class="required" title="obligatorio">*</span>
                    </label>
                    <input type="password" class="form-control" id="confirm-password"
                        [ngClass]="{'is-invalid': shouldShowError('confirmPassword', password2)}"
                        [(ngModel)]="password2" (ngModelChange)="checkValid()" (blur)="markAsTouched('confirmPassword')"
                        required>
                    <div *ngIf="shouldShowError('confirmPassword', password2)" class="invalid-feedback" i18n>
                        Campo requerido
                    </div>
                </div>

                <small class="col-12 mb-3 small-text" i18n>
                    * La contraseña debe tener entre 8 y 30 caracteres, e incluir números, símbolos, mayúsculas y
                    minúsculas.
                </small>
            </div>
        </div>

        <div class="my-4" i18n>Protección de datos</div>
        <div class="mb-3 check-legal">
            <input class="form-check-input" type="checkbox" [(ngModel)]="applicant.flags!.veracity" id="data-treatment">
            <label for="data-treatment" class="ml-3">
                <span i18n>La persona firmante responde personalmente sobre la veracidad de los datos manifestados,
                    acepta y es consciente de que, en caso de comprobarse la falsedad de los datos expuestos en la
                    solicitud, podría perder cualquier derecho al servicio.</span>
                <a routerLink="/privacy" target="_blank" i18n>Política de privacidad</a>.
            </label>
        </div>
        <div class="mb-3 check-legal">
            <input class="form-check-input" type="checkbox" [(ngModel)]="applicant.flags!.privacity"
                (ngModelChange)="checkValid()" id="privacy">
            <label for="privacy" class="ml-3">
                <span i18n>Acepto la política de privacidad, para mas información haz clic </span>
                <a routerLink="/privacy" target="_blank" i18n>aquí</a>.
            </label>
        </div>
        <div class="check-legal mb-3">
            <span i18n>En cumplimiento de lo dispuesto en la normativa de protección de datos vigente, se le informa que
                en función de la ZBE en la que haya presentado la documentación, las datos facilitados serán tratados
                por el municipio correspondiente de este listado de <a routerLink="/town-halls">ayuntamientos</a> con la
                finalidad de tramitar su solicitud. Puede ejercer sus derechos y obtener más información consultando la 
                <a routerLink="/privacy">Política de Privacidad</a>.</span>
        </div>
        <div class="form-check my-4">
            <span class="required" title="Obligatorio">*</span>
            <small class="text-danger" i18n>Es necesario rellenar todos los campos obligatorios.</small>
        </div>

        <button type="button" class="btn btn-secondary" i18n (click)="createApplicant()">Enviar</button>
    </div>
</main>